module.exports = __webpack_public_path__ + "img/icon-snow.0983109a.svg";